import { Autocomplete, TextField, Grid } from '@mui/material';
import { filter } from 'lodash';
import React, { useContext } from 'react';

import { ProjectContext } from '../../../Contexts/Project/Context';

import ManagersList from './ManagersList';

const ProjectManagers: React.FC = () => {
  const { project, onProjectDataChange, managers } = useContext(ProjectContext);

  const selectedIds = (project.projectUsers ?? [])
    .map((u) => u.employmentId || u.companyResourceId || u.userId)
    .filter(Boolean);

  const availableManagers = filter(
    managers,
    (man) => !selectedIds.includes(man.id) && (!man.user?.id || !selectedIds.includes(man.user.id)),
  );

  return (
    <Grid container mt={2}>
      {managers && (
        <Autocomplete
          fullWidth
          size="small"
          options={availableManagers}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          blurOnSelect
          clearOnBlur
          value={null}
          onChange={(_, newValue) => {
            if (!newValue) return;
            onProjectDataChange('projectUsers', [
              ...(project.projectUsers ?? []),
              {
                employmentId: newValue.id,
                userId: newValue.user?.id,
                title: '',
              },
            ]);
          }}
          getOptionLabel={(option) => option.name || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Project Manager"
              label="Project Managers (Optional)"
              slotProps={{
                htmlInput: {
                  ...params.inputProps,
                  autoComplete: 'off',
                },
              }}
            />
          )}
        />
      )}
      <ManagersList />
    </Grid>
  );
};

export default ProjectManagers;
